import { render, staticRenderFns } from "./inteGoodsList.vue?vue&type=template&id=674a42cd"
import script from "./inteGoodsList.vue?vue&type=script&lang=js"
export * from "./inteGoodsList.vue?vue&type=script&lang=js"
import style0 from "./inteGoodsList.vue?vue&type=style&index=0&id=674a42cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports